import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import styles from "./TabBar.module.scss"
import { IInventoryTab, ITabBarProps } from "./types"

const TABS: IInventoryTab[] = ["equipment", "consumables", "resources"]

export const TabBar: FC<ITabBarProps> = ({ active, onChange }) => {
  const { t } = useTranslation("inventory")
  return (
    <div className={styles.TabBar}>
      {TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          className={clsx(styles.TabBar_tab, {
            [styles.active]: tab === active
          })}
          onClick={() => onChange(tab)}
        >
          {t(`tab.${tab}`)}
        </button>
      ))}
    </div>
  )
}
